import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse, faCode, faFont, faTextWidth, faCodeCompare,
  faFileExcel, faRandom, faImages
} from '@fortawesome/free-solid-svg-icons';
import { 
  TbJson, TbArrowsExchange, TbCsv, TbRegexOff, TbCodeAsterisk, TbColorFilter,
  TbClock12, TbQrcode, TbCalculator, TbBrandFacebook, TbTextColor, TbDatabase,
  TbTransform, TbLink, TbTextSize, TbNotebook, TbUser, TbSql,
  TbImageInPicture, TbTerminal2, TbLinkMinus, TbTools, TbBarcode, TbVideo, TbPlayerPlay, TbDownload,
  TbSquareLetterS, TbFileDiff, TbPictureInPicture, TbPhoto, TbBrandTwitter, TbBrandTwitterFilled,
  TbPictureInPictureFilled,
} from "react-icons/tb";
import { VscJson, VscLock } from "react-icons/vsc";
import descContants from './descContants';
import _ from 'lodash';

const lightIconColor = 'rgb(17 24 39 / var(--tw-text-opacity))'
const darkIconColor = 'rgb(229 231 235 / var(--tw-text-opacity))'

const yamlIconSvg = (appTheme = 'light') => {
  let color = lightIconColor
  if (appTheme === 'dark') {
    color = darkIconColor
  }
  return (
    <svg width="24" height="24" viewBox="0 0 24 24"><path fill={color} d="m 1,1.8886505 3.7675781,5.916015 V 11.554666 H 7.1875 V 7.8046655 l 3.943359,-5.916015 H 8.529297 L 6.1132813,5.6972445 3.71875,1.8886505 Z m 11.085938,0.02148 -4.09961,9.6660155 h 1.939453 l 0.890625,-2.1484375 h 4.375 c 0.245424,0.7164085 0.492763,1.4319615 0.738282,2.1484375 H 18 L 14.068359,1.9101305 Z m 1.037109,2.041016 1.341797,3.546875 h -2.837891 z m 2.806641,8.6855465 v 9.43164 H 23 v -2.015625 h -5 v -7.416014 z m -11.1621099,0.002 v 9.472656 h 2.0332032 v -6.535156 l 2.1269527,4.392579 h 1.59961 l 2.201172,-4.546875 v 6.6875 h 1.949218 V 12.638693 H 12.015625 L 9.652344,16.921896 7.4023438,12.638693 Z"></path></svg>
  )
}

const colorTheme = localStorage.getItem('color-theme');
const userSettings = {
  colorTheme: colorTheme,
  editorTheme: `vs-${colorTheme}`
}

const sidebarConfig = [
  { name: 'Demo Page', url: '/demo', icon: null, hidden: true },
  { name: 'Home', url: '/', icon: <FontAwesomeIcon icon={faHouse}/>, isHome: true },
  { name: 'Home', url: '/app', icon: <FontAwesomeIcon icon={faHouse}/>, isHome: true, hidden: true },
  {
    name: 'Text Tools',
    url: '#text-tools',
    icon: <FontAwesomeIcon icon={faFont}/>,
    sub: [
      {
        name: 'Facebook Font', pageTitle: 'Facebook Font Changer',
        url: '/facebook-text', icon: <TbBrandFacebook style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: descContants.fbFontChanger
      },
      {
        name: 'Fancy Text', pageTitle: 'Fancy Text Generator',
        url: '/fancy-text', icon: <TbTextColor style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: descContants.fancyText
      },
      {
        name: 'Text Size Calculator', pageTitle: 'Text(String) Size Calculator',
        url: '/text-size-calculator', icon: <FontAwesomeIcon icon={faTextWidth}/>,
        description: 'Calculate the byte size of any text or string without spaces with our free online string byte size calculator. Simple and quick byte calculation.'
      },
      {
        name: 'Text Diff Checker', pageTitle: 'Text(String) Diff Checker',
        url: '/text-diff-checker', icon: <FontAwesomeIcon icon={faCodeCompare}/>,
        description: 'Find the difference between two text documents.'
      },
      {
        name: 'Case Converter', pageTitle: 'Case Converter',
        url: '/case-converter', icon: <TbTextSize style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      {
        name: 'Lorem Ipsum', pageTitle: 'Lorem Ipsum Generator',
        url: '/lorem-ipsum-generator', icon: <TbNotebook style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      {
        name: 'ASCII Art Text', pageTitle: 'ASCII Art Text Generator',
        url: '/ascii-art-text-generator', icon: <TbPhoto style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      }
    ]
  },
  {
    name: 'JSON Tools', url: '#json-tools', icon: <TbCodeAsterisk style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
    sub: [
      { 
        name: 'JSON Beautifier', pageTitle: 'JSON Beautifier',
        url: '/beautiful-json', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON Minifier', pageTitle: 'JSON Minifier',
        url: '/minifier-json', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON Query', pageTitle: 'JSON Query',
        url: '/json-query', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: 'Query JavaScript objects with JSONPath expressions.'
      },
      { 
        name: 'JSON to YAML', pageTitle: 'Transform JSON into YAML',
        url: '/json-2-yaml', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON to CSV', pageTitle: 'Transform JSON into CSV',
        url: '/json-2-csv', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Object to JSON', pageTitle: 'Transform Object (Ruby Hash) into JSON',
        url: '/object-2-json', icon: <VscJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON Tree Viewer', pageTitle: 'JSON Tree Viewer',
        url: '/json-tree-viewer', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON Visualizer', pageTitle: 'JSON Visualizer',
        url: '/json-visualizer', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'JSON Diff Checker', pageTitle: 'JSON Diff Checker',
        url: '/json-diff-checker', icon: <TbFileDiff style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      }
    ]
  },
  {
    name: 'YAML Tools', url: '#yaml-tools',
    icon: yamlIconSvg(), iconDark: yamlIconSvg('dark'),
    sub: [
      { 
        name: 'YAML to JSON', pageTitle: 'Transform YAML into JSON',
        url: '/yaml-2-json', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
    ]
  },
  {
    name: 'Image Tools', url: '#image-tools',
    icon: <FontAwesomeIcon icon={faImages}/>,
    sub: [
      { 
        name: 'Code to Image', pageTitle: 'Code to Image Converter',
        url: '/code-to-image', icon: <TbTerminal2 style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: 'Make beautiful images of your source code'
      },
      { 
        name: 'Tweet to Image', pageTitle: 'Tweet to Image Converter',
        url: '/text-to-tweet-image', icon: <TbBrandTwitter style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Tweet Generator', pageTitle: 'Tweet Generator',
        url: '/tweet-generator', icon: <TbBrandTwitterFilled style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Remove Background', pageTitle: 'Remove Background Image',
        url: '/remove-background', icon: <TbPhoto style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
    ]
  },
  {
    name: 'Random Tools', url: '#random-tools',
    icon: <FontAwesomeIcon icon={faRandom}/>,
    sub: [
      {
        name: 'Lorem Ipsum', pageTitle: 'Lorem Ipsum Generator',
        url: '/lorem-ipsum-generator', icon: <TbNotebook style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      {
        name: 'Person Randomizer', pageTitle: 'Person Randomizer',
        url: '/random-person', icon: <TbUser style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      }
    ]
  },
  {
    name: 'CSV Tools', url: '#csv-tools', icon: <TbCsv style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
    sub: [
      {
        name: 'CSV to JSON', pageTitle: 'Transform CSV into JSON',
        url: '/csv-2-json', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'CSV Preview', pageTitle: 'CSV Preview',
        url: '/csv-preview', icon: <TbCsv style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
    ]
  },
  {
    name: 'Excel Tools', url: '#excel-tools',
    icon: <FontAwesomeIcon icon={faFileExcel} />,
    sub: [
      { 
        name: 'Excel to JSON', pageTitle: 'Transform Excel into JSON',
        url: '/excel-2-json', icon: <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
    ]
  },
  {
    name: 'Database Tools', url: '#database-tools',
    icon: <TbDatabase style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
    sub: [
      { 
        name: 'Schema Transform', pageTitle: 'Schema Transform',
        url: '/schema-transform', icon: <TbTransform style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'SQL Formater', pageTitle: 'SQL Formater',
        url: '/sql-formater', icon: <TbSql style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
    ]
  },
  {
    name: 'Coding tools',
    url: '#coding-tools',
    icon: <FontAwesomeIcon icon={faCode}/>,
    sub: [
      { 
        name: 'Excel to JSON', pageTitle: 'Transform Excel into JSON',
        url: '/excel-2-json', icon: <FontAwesomeIcon icon={faFileExcel} />,
      },
      { 
        name: 'Unit Converter', pageTitle: 'Unit Converter',
        url: '/unit-converter', icon: <TbCalculator style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: 'Use our online unit converters to easily convert the values from one system of units to another.'
      },
      { 
        name: 'Cron Job Parser', pageTitle: 'Cron Job Parser',
        url: '/cron-job-parser', icon: <TbClock12 style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
        description: 'Parse, validate and debug cron expressions. See breakdown of different segments of time.'
      },
      { 
        name: 'Color Picker', pageTitle: 'Color Picker',
        url: '/color-picker', icon: <TbColorFilter style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Regex Tester', pageTitle: 'Regex Tester',
        url: '/regex-tester', icon: <TbRegexOff style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Base64', pageTitle: 'Base64 Encode/Decode',
        url: '/base64', icon: <TbCodeAsterisk style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'URL Encode/Decode', pageTitle: 'URL Encode/Decode',
        url: '/url-encode', icon: <TbLink style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'URL Encode/Decode', pageTitle: 'URL Encode/Decode', hidden: true,
        url: '/url-decode', icon: <TbLink style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'URL Slug Generator', pageTitle: 'URL Slug Generator',
        url: '/url-slug-generator', icon: <TbLinkMinus style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Code Diff Checker', pageTitle: 'Code Diff Checker',
        url: '/code-diff-checker', icon: <TbFileDiff style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      }
    ]
  },
  {
    name: 'Other Tools',
    url: '#other-tools',
    icon: <TbTools style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
    sub: [
      { 
        name: 'QR Code Generator', pageTitle: 'QR Code Generator',
        url: '/qr-code-generator', icon: <TbQrcode style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'QR Code Reader', pageTitle: 'QR Code Reader',
        url: '/qrcode-reader', icon: <TbQrcode style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Password Generator', pageTitle: 'Strong Random Password Generator',
        url: '/password-generator', icon: <VscLock style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Barcode Generator', pageTitle: 'Barcode Generator',
        url: '/barcode-generator', icon: <TbBarcode style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'Extract SEO Metadata', pageTitle: 'Extract SEO Metadata from URL',  hidden: true,
        url: '/extract-seo-from-url', icon: <TbSquareLetterS style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      },
      { 
        name: 'FB Video Downloader', pageTitle: 'Facebook Video Downloader',
        url: '/fb-download', icon: <TbDownload style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />,
      }
    ]
  }
];
let allFeatures = []
sidebarConfig.map((parent) => {
  if (parent.sub) {
    allFeatures = allFeatures.concat(parent.sub)
  }
})
allFeatures =allFeatures.sort((a, b) => a.name.localeCompare(b.name))

const appConfig = {
  sidebarConfig: sidebarConfig,
  userSettings: userSettings,
  allFeatures: allFeatures
}

export default appConfig;
